import { render } from "./TeamSlides.vue?vue&type=template&id=a6bbaaa0&scoped=true"
import script from "./TeamSlides.vue?vue&type=script&lang=js"
export * from "./TeamSlides.vue?vue&type=script&lang=js"

import "./TeamSlides.vue?vue&type=style&index=0&id=a6bbaaa0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6bbaaa0"]])

export default __exports__